const getDefaultState = () => ({
  remember_me: false,
  pwa: false,
})

export const state = getDefaultState()

export const mutations = {
  setRememberMe(
    state,
    rememberMe
  ) {
    state.remember_me =
      !!rememberMe
  },

  setPWA(state, pwa) {
    state.pwa = !!pwa
  },
}

export const actions = {
  setRememberMe(
    { commit },
    preference
  ) {
    commit(
      'setRememberMe',
      preference
    )
  },

  setPWA(
    { commit },
    preference
  ) {
    commit(
      'setPWA',
      preference
    )
  },
}

export const getters = {
  getRememberMe: (state) =>
    state.remember_me,

  getPWA: (state) =>
    state.pwa,
}